import React from 'react';

import { classNames } from '@/helpers/classNames';
import { Button, SvgIcon } from '@material-ui/core';

import styles from './AsaphTopNavigationButton.module.scss';

export interface AsaphNavigationButtonProps {
	label: string;
	defaultIcon?: React.ElementType;
	selectedIcon?: React.ElementType;
	isSelected?: boolean;
	url: string;
	onClick?: () => void;
	hasNotification?: boolean;
	hidden?: boolean;
	desktopOnly?: boolean;
	key: string;
	style?: React.CSSProperties;
	className?: string;
	trailingComponent?: React.ReactElement;
}

export const AsaphTopNavigationButton = ({
	label,
	defaultIcon,
	selectedIcon,
	isSelected,
	onClick,
	hasNotification,
	style,
	className,
	trailingComponent,
}: AsaphNavigationButtonProps & { onClick: () => void }) => (
	<div
		className={classNames([
			styles['root'],
			isSelected && styles['selected'],
			className,
		])}
		onClick={onClick}
	>
		{defaultIcon && (
			<div className={styles['icon']}>
				<SvgIcon
					component={
						isSelected && selectedIcon ? selectedIcon : defaultIcon
					}
					style={style}
				/>
				{hasNotification && <div className={styles['notification']} />}
			</div>
		)}
		<div className={styles['label-container']}>
			<div className={styles['label']}>{label}</div>
			{trailingComponent && (
				<div className={styles['trailing']}>{trailingComponent}</div>
			)}
		</div>
	</div>
);
